import { Pivot, PivotItem } from '@fluentui/react';
import AssetHierarchy from './AssetHierarchy';
import AssetIssues from './AssetIssues';
import { useLocation } from 'react-router-dom';
import AssetDetailsV2 from './AssetDetailsV2';
import { Features, useFeatureFlag } from '../../libs/featureAccess';

const Asset = () => {
  const query = new URLSearchParams(useLocation().search);
  const assetId = Number.parseInt(query.get('id') ?? '');
  const { isEnabled: isIssuesEnabled } = useFeatureFlag(
    Features.FEATURE_ISSUES
  );
  const { isEnabled: isHierarchyEnabled } = useFeatureFlag(
    Features.FEATURE_ASSET_HIERARCHY
  );

  return (
    <Pivot defaultSelectedKey="fields">
      <PivotItem headerText="Fields" itemKey="fields">
        <AssetDetailsV2 />
      </PivotItem>
      {isIssuesEnabled && (
        <PivotItem headerText="Issues" itemKey="issues">
          <AssetIssues assetId={assetId} />
        </PivotItem>
      )}
      {isHierarchyEnabled && (
        <PivotItem headerText="Hierarchy" itemKey="hierarchy">
          <AssetHierarchy assetId={assetId} />
        </PivotItem>
      )}
    </Pivot>
  );
};

export default Asset;
